<template>
	<div class="wrapper">
		<headerTag />
			<p class="userIn1" style="margin-top: 6.15rem; margin-bottom: 0;">
				<input type="number" placeholder="QQ号"  oninput="if(value.length>11)value=value.slice(0,12)" autocomplete="off" v-model='qq'
                    onkeyup="this.value=this.value.replace(/[^\d\.]/g,'')" ref="qq"/>
				<img src="../../assets/images/user/qq.png" alt="" />
			</p>
			<button class="userBtn1" @click="editUserInfo" :disabled="isDisable">完成</button>
		<footerTag />
	</div>

</template>

<script>
   
    import "../../assets/css/user.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
    import footerTag from '@/components/footerTag/footerTag.vue'
	import {VidateUtil} from '../../assets/js/validate.js' 
	import { Dialog } from 'vant'

	export default {
		name: 'qqChange',
		props: {
        
		},
		data:function(){
			return {
				isDisable:false,
				qq:'',
			}
		},
		methods:{
			loadUserInfo(){
				this.axios({
				    method: 'POST',
				    url:'/user/userInfo',
				}).then((res)=>{
						if(res.data.code==1000){
							 let resultData = res.data.data.user;
							 this.qq = resultData.qq;
						}else if(res.data.code == 1110){
				  			//未登录
				  			let currPath=window.location.href;
				  			window.location.href='/login?targetUrl='+currPath;
				  		}else{
				  			this.$message.error({message: res.data.message});
				  		}
				}).catch((err)=>{
				    this.$message.error({message: '网络异常，请稍后重试'});
				})
			},
			editUserInfo(){
				let qq=this.$refs.qq.value;
				if(qq == '' || qq == null){
					this.$message.error({message: 'QQ号不能为空'});
					return;
				}
				if(qq!=null && qq!=''&&(!VidateUtil.checkQQ(qq))){
					this.$message.error({message: 'QQ格式输入有误'});
					return;
				}
				//按钮不可点击
				this.isDisable=true; 
				this.axios({
					method: 'POST',
					url:'/user/saveUserInfo',
					params:{
						qq:qq,
					},
				}).then((res)=>{
						this.isDisable=false; //按钮可点击
						if(res.data.code==1000){
							//成功
							Dialog.alert({
							  message: '修改成功'
							}).then(() => {
							  this.$router.push({ name:'baseMessage' });
							});
						}else if(res.data.code==1002){
							this.$refs.qq.value=""; //置空
							this.$message.error({message: res.data.message});
						}else if(res.data.code == 1110){
				  			//未登录
				  			let currPath=window.location.href;
				  			window.location.href='/login?targetUrl='+currPath;
				  		}else{
							this.$message.error({message: '网络异常，请稍后重试'});
						}
				}).catch((err)=>{
					this.isDisable=false; //按钮可点击
					this.$message.error({message: '网络异常，请稍后重试'});
				})
			}
		},
		components: {
			headerTag,
			footerTag,
			VidateUtil
		},
		created(){
			this.loadUserInfo();
		}
	}

</script>